var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7621 0.50016C15.3931 0.50016 16.0231 0.58916 16.6221 0.79016C20.3131 1.99016 21.6431 6.04016 20.5321 9.58016C19.9021 11.3892 18.8721 13.0402 17.5231 14.3892C15.5921 16.2592 13.4731 17.9192 11.1921 19.3492L10.9421 19.5002L10.6821 19.3392C8.39313 17.9192 6.26213 16.2592 4.31313 14.3792C2.97313 13.0302 1.94213 11.3892 1.30213 9.58016C0.172126 6.04016 1.50213 1.99016 5.23313 0.76916C5.52313 0.66916 5.82213 0.59916 6.12213 0.56016H6.24213C6.52313 0.51916 6.80213 0.50016 7.08213 0.50016H7.19213C7.82213 0.51916 8.43213 0.62916 9.02313 0.83016H9.08213C9.12213 0.84916 9.15213 0.87016 9.17213 0.88916C9.39313 0.96016 9.60213 1.04016 9.80213 1.15016L10.1821 1.32016C10.2739 1.36913 10.377 1.44396 10.4661 1.50863C10.5225 1.5496 10.5733 1.5865 10.6121 1.61016C10.6284 1.61979 10.645 1.62947 10.6617 1.63923C10.7475 1.68928 10.8368 1.74142 10.9121 1.79916C12.0231 0.95016 13.3721 0.49016 14.7621 0.50016ZM17.4219 7.70064C17.8319 7.68964 18.1819 7.36064 18.2119 6.93964V6.82064C18.2419 5.41964 17.3929 4.15065 16.1019 3.66065C15.6919 3.51964 15.2419 3.74064 15.0919 4.16065C14.9519 4.58065 15.1719 5.04065 15.5919 5.18964C16.2329 5.42965 16.6619 6.06065 16.6619 6.75964V6.79064C16.6429 7.01964 16.7119 7.24064 16.8519 7.41065C16.9919 7.58065 17.2019 7.67965 17.4219 7.70064Z",
    fill: "#999CAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1c9d0081493686cba854a1f73e9c87c2.svg";
export { ForwardRef as ReactComponent };